import { useState } from 'react';
import { IconDown, IconUp } from '@ui/src';
import CardItem from './item';
import { OrganizationType } from '../../../hoc/common/types';
import { CardsListTypes } from './types';
import { CardType } from '../../../hoc/common/cards/types';

import cn from './styles.module.css';

const CardsList = ({
  cards,
  onStatusChange,
  updatedCard,
  statusChangeInProgress,
  customerType,
  customerId,
  changeStatusInProgress,
  changeStatusSuccess,
  activePermissions,
}: CardsListTypes) => {
  const [corporateCardsVisible, setCorporateCardsVisible] = useState(false);

  let nextCards;

  if (customerType === OrganizationType.INDIVIDUAL) {
    nextCards = cards?.filter((item) => item.type === CardType.DEBIT);
  } else {
    nextCards = cards?.filter((item) => item.type === CardType.CORP);
  }

  const corpCards = cards?.filter((item) => item.type === CardType.CORP);

  return (
    <>
      {nextCards.map((item, index) => (
        <CardItem
          key={item.id}
          card={item}
          onStatusChange={onStatusChange}
          updatedCard={updatedCard}
          statusChangeInProgress={statusChangeInProgress}
          customerId={customerId}
          zIndex={nextCards.length - index}
          changeStatusInProgress={changeStatusInProgress}
          changeStatusSuccess={changeStatusSuccess}
          customerType={customerType}
          activePermissions={activePermissions}
        />
      ))}
      {customerType === OrganizationType.INDIVIDUAL &&
        corpCards?.length > 0 && (
          <>
            <button
              type="button"
              className={cn.corpCardsButton}
              onClick={() => setCorporateCardsVisible(!corporateCardsVisible)}
            >
              {`${corpCards.length} corporate cards`}
              {corporateCardsVisible ? (
                <IconUp className={cn.corpCardsButtonIcon} />
              ) : (
                <IconDown className={cn.corpCardsButtonIcon} />
              )}
            </button>
            {corporateCardsVisible &&
              corpCards.map((item, index) => (
                <CardItem
                  key={item.id}
                  card={item}
                  onStatusChange={onStatusChange}
                  updatedCard={updatedCard}
                  statusChangeInProgress={statusChangeInProgress}
                  customerId={customerId}
                  zIndex={corpCards.length - index}
                  changeStatusInProgress={changeStatusInProgress}
                  changeStatusSuccess={changeStatusSuccess}
                  customerType={customerType}
                  activePermissions={activePermissions}
                />
              ))}
          </>
        )}
    </>
  );
};

export default CardsList;
